import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Services } from './components/Services';
import { Process } from './components/Process';
import { FAQ } from './components/FAQ';
import { Contact } from './components/Contact';
import { AgencyPopup } from './components/AgencyPopup';
import { Header } from './components/Header';
function App() {
  return <div className="min-h-screen bg-white font-sans selection:bg-black selection:text-white" data-id="element-0">
      <Header data-id="element-1" />
      <Hero data-id="element-2" />
      <PainPoints data-id="element-3" />
      <Services data-id="element-4" />
      <Process data-id="element-5" />
      <FAQ data-id="element-6" />
      <Contact data-id="element-7" />

      <footer className="py-12 text-center text-neutral-400 text-sm bg-white border-t border-neutral-100" data-id="element-8">
        <p className="uppercase tracking-widest" data-id="element-9">
          © {new Date().getFullYear()} Адвокатські послуги. Всі права захищені.
        </p>
      </footer>

      <AgencyPopup data-id="element-10" />
    </div>;
}
export { App };